import { ThemeMode } from '../types/timer';

const THEME_KEY = 'pomodoro-theme';

export function getSystemTheme(): 'light' | 'dark' {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function getStoredTheme(): ThemeMode {
  return (localStorage.getItem(THEME_KEY) as ThemeMode) || 'system';
}

export function applyTheme(theme: ThemeMode) {
  // Store theme preference
  localStorage.setItem(THEME_KEY, theme);
  
  // Determine effective theme
  const effectiveTheme = theme === 'system' ? getSystemTheme() : theme;
  
  // Apply theme without transitions
  document.documentElement.classList.add('theme-transition-disabled');
  
  // Apply theme
  if (effectiveTheme === 'dark') {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
  
  // Re-enable transitions after a brief delay
  requestAnimationFrame(() => {
    document.documentElement.classList.remove('theme-transition-disabled');
  });
}